import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/layout/SiteLayout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <Category /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "search", element: <Search /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;